module.exports = __webpack_public_path__ + "img/re_event1.7a6bceb5.png";